// extracted by mini-css-extract-plugin
module.exports = {"historyList":"statusList_historyList__1Dl0t","active":"statusList_active__3RZ3Z"};